module.exports = __webpack_public_path__ + "static/img/bg_about_a.2171db94.png";